import SubcategoriesPresenter from "../components/subcategories/presenter/subcategories.js";

const subcategoriesWrapper = document.querySelector(`.subcategories-wrapper`);
const categoriesButton = document.querySelector(`.button_subcategories`);

if (subcategoriesWrapper) {
  const subcategoriesComponent = new SubcategoriesPresenter(subcategoriesWrapper, categoriesButton);
  subcategoriesComponent.init();
}
